export class CurrentBalanceEventType {

	static BALANCE_UPDATE = 'BALANCE_UPDATE';

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/current-balance/current-balance.event.type.ts